import React from 'react';
import { useTranslation } from 'react-i18next';
import './employer-certificate-header.component.scss';
import { INVOZIO_BLOB_BASE } from '../../constant/video-url-import.constant';
const tutorialIcon = <svg width={20} height={20} viewBox="0 0 100 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="70" fill="#6A5ACD" />
    <rect x="8" y="8" width="84" height="54" fill="#6A5ACD" />
    <path d="M42 25V45L58 35L42 25Z" fill="#FFFFFF" />
    <rect y="70" width="100" height="5" fill="#ffffff" />
    <rect y="75" width="100" height="10" fill="#6A5ACD" />
</svg>;

const videoUrlEn = `${INVOZIO_BLOB_BASE}/employer_certificate_en.mp4`
const videoUrlSv = `${INVOZIO_BLOB_BASE}/employer_certificate_sv.mp4`

export const EmployerCertificateHeader: React.FC = () => {
    const { t } = useTranslation();
    const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
    const isSv = lang === 'en-us' ? false : true
    const handleButtonClick=() =>{
      window.open(isSv ? videoUrlSv : videoUrlEn, '_blank', 'noopener,noreferrer');
    }

    return (
        <div className="employer-certificate-header">
            <div className="employer-certificate-header__card">
                {/* <div className='employer-certificate-header__title-btn'> */}
                <h1 className="employer-certificate-header__title">
                    {t('Employer Certificate')}
                </h1>
                {/* </div> */}
                <p className="employer-certificate-header__description">
                    {t('employerCertificateDescription')}
                </p>
                <button className='employer-certificate-header__button' onClick={handleButtonClick}>
                    <div>{tutorialIcon}</div>
                    <div>{t('employerCertificateTutorial')}</div>
                </button>
            </div>
        </div>
    );
};
